import { render, staticRenderFns } from "./OverviewPage.vue?vue&type=template&id=1cb50ba2&"
import script from "./OverviewPage.vue?vue&type=script&lang=js&"
export * from "./OverviewPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports